document.querySelectorAll('.btn--loader').forEach((button) => {
	// Wrap button content in a span.
	button.innerHTML = `<span>${button.innerHTML}</span>`;
});
